import { configureStore } from '@reduxjs/toolkit'
import authReducer from './slices/authSlice'
import grantReducer from './slices/grantSlice'
import statsReducer from './slices/statsSlice'
import { authApi, grantUserApi, grantApi, workApi, crossrefApi, statsApi } from './api'

export const store = configureStore({
  reducer: {
    auth: authReducer,
    grant: grantReducer,
    stats: statsReducer,
    [authApi.reducerPath]: authApi.reducer,
    [grantApi.reducerPath]: grantApi.reducer,
    [grantUserApi.reducerPath]: grantUserApi.reducer,
    [workApi.reducerPath]: workApi.reducer,
    [crossrefApi.reducerPath]: crossrefApi.reducer,
    [statsApi.reducerPath]: statsApi.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat([
      authApi.middleware,
      grantApi.middleware,
      grantUserApi.middleware,
      crossrefApi.middleware,
      workApi.middleware,
      statsApi.middleware,
    ]),
})
export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch
